import { IQuestionnaireState } from './states/questionnaire.state';

const STORAGE_KEY = 'questionnaire-state';

/** Persist the whole questionnaire feature state so it survives a store reset on later steps (payment). */
export function saveQuestionnaireState(state: IQuestionnaireState): void {
  if (typeof localStorage === 'undefined') {
    return;
  }
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  } catch {
    /* localStorage unavailable (blocked / quota) */
  }
}

/** Read the persisted questionnaire state (null if absent / unavailable / corrupt). */
export function readQuestionnaireState(): IQuestionnaireState | null {
  if (typeof localStorage === 'undefined') {
    return null;
  }
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? (JSON.parse(raw) as IQuestionnaireState) : null;
  } catch {
    return null;
  }
}
